// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_1oq_xM4C-mLW7vcOKUpv1J","doubleBounce1":"_2NTiL7xMT1lzGX0s5HUG3E","doubleBounce2":"_17tXfNAtG3ms-AChRfl2xK","skBounce":"_1-CSEK9z_45CqmH_rzbGLz"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Spinner/Bounce/style.css
// module id = 1358
// module chunks = 0